// PromotionAnalytics.client.jsx
// This is a new client component for handling promotion analytics
// Where: This component is used in the ContentOverImage component which is a server component, hence the need for a client component
// Why: We need to track when a promotion is viewed
// How: We use the ClientAnalytics.publish method to send a view_promotion event
// When: When the component mounts

import {useEffect} from 'react';
import {ClientAnalytics} from '@shopify/hydrogen';
import {v4 as uuidv4} from 'uuid';
const publishedEvents = new Set();

export function PromotionAnalytics({promotionTracking}) {
  useEffect(() => {
    // Ensure promotionTracking is provided and contains a valid creativeName
    if (promotionTracking?.enabled && promotionTracking.creativeName) {
      const eventId = promotionTracking.creativeName;

      // Check if the component hasn't been initialized yet
      if (!publishedEvents.has(eventId)) {
        publishedEvents.add(eventId);
        ClientAnalytics.publish('view_promotion', false, {
          creative_name: promotionTracking.creativeName,
          promotion_id: promotionTracking.creativeName.replace(/[^a-zA-Z0-9]/g, "-"),
        });
      }
    }
  }, [promotionTracking]); // Include promotionTracking in dependencies array

  // This component doesn't render anything, so you can return null
  return null;
}
